var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-container"},[_c('video',_vm._g(_vm._b({ref:"source",staticClass:"video-source",attrs:{"autoplay":"","playsinline":""}},'video',_vm.$attrs,false),_vm.$listeners),[_c('source',{attrs:{"src":_vm.src,"type":"video/mp4; codecs=\"avc1.42E01E\""}})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43e55c64","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-svg-inline-loader/dist/index.min.js??ref--6!./src/components/base/Video.vue
// module id = null
// module chunks = 